import PropTypes from "prop-types"
import React from "react"

const Address = ({
  name,
  addressLineOne,
  addressLineTwo,
  city,
  state,
  zip,
  displayPhone,
  email,
  showPhone = false,
  showEmail = false,
}) => {
  return (
    <div>
      <div>{name}</div>
      {addressLineOne && (
        <div data-testid="address-line-one">{addressLineOne}</div>
      )}
      {addressLineTwo && (
        <div data-testid="address-line-two">{addressLineTwo}</div>
      )}
      {[city, state, zip].some(Boolean) && (
        <div data-testid="city-state-zip">
          {city}
          {city && (state || zip) ? "," : ""} {state} {zip}
        </div>
      )}
      {showPhone && <div data-testid="display-phone">{displayPhone}</div>}
      {showEmail && <div data-testid="email">{email}</div>}
    </div>
  )
}

Address.propTypes = {
  name: PropTypes.string.isRequired,
  addressLineOne: PropTypes.string,
  addressLineTwo: PropTypes.string,
  city: PropTypes.string,
  state: PropTypes.string,
  zip: PropTypes.string,
  displayPhone: PropTypes.string,
  email: PropTypes.string,
  showPhone: PropTypes.bool,
  showEmail: PropTypes.bool,
}
export default Address
